import * as Sentry from '@sentry/browser'
import {Config} from '../../config.js'

Sentry.init({
	dsn                     : Config.sentry.dsn_client,
	environment             : Config.environment,
	tracesSampleRate        : Config.sentry.sample_rate,
	sendDefaultPii          : Config.sentry.send_pii,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
	integrations            : [
		Sentry.browserTracingIntegration,
		Sentry.replayIntegration,
	],
})

require('../../style/vendor/tailwind.css')

window.$ = window.jQuery = require('jquery')

require('@fortawesome/fontawesome-free/css/all.min.css')

require('@splidejs/splide/dist/css/splide.min.css')
require('@splidejs/splide/dist/js/splide.min.js')

require('animate.css/animate.min.css')

require('daterangepicker/daterangepicker.css')
require('daterangepicker/daterangepicker.js')

require('dayjs/dayjs.min.js')

require('izitoast/dist/css/iziToast.min.css')
require('izitoast/dist/js/iziToast.min.js')

require('jfilestyle/src/jquery-filestyle.min.css')
require('jfilestyle/src/jquery-filestyle.min.js')

require('js-cookie/dist/js.cookie.min.js')

require('lazyload/lazyload.min.js')

require('magnific-popup/dist/magnific-popup.css')
require('magnific-popup/dist/jquery.magnific-popup.min.js')

require('pretty-checkbox/dist/pretty-checkbox.min.css')

require('remodal/dist/remodal.css')
require('remodal/dist/remodal-default-theme.css')
require('remodal/dist/remodal.min.js')

require('tom-select/dist/css/tom-select.min.css')
require('tom-select/dist/js/tom-select.complete.min.js')

require('sortablejs/Sortable.min.js')

require('sweetalert2/dist/sweetalert2.min.js')
require('@sweetalert2/theme-material-ui/material-ui.min.css')

require('tablefilter/dist/tablefilter/tablefilter.js')

require('tablesorter/dist/js/jquery.tablesorter.min.js')

require('tippy.js/dist/tippy.cjs.js')
require('tippy.js/dist/tippy.css')

require('../../style/*.styl')
require('../../style/vendor/*.styl')
require('./style/*.styl')

window.App = {
	_common      : require('./client/_common.js').default,
	Close        : require('./client/close.js').default,
	Customer     : require('./client/customer.js').default,
	Error        : require('./client/error.js').default,
	Index        : require('./client/index.js').default,
	Open         : require('./client/open.js').default,
	Pos          : require('./client/pos.js').default,
	Menu         : require('./client/menu.js').default,
	Sale         : require('./client/sale.js').default,
	Shift        : require('./client/shift.js').default,
	Shift_pattern: require('./client/shift_pattern.js').default,
	Staff        : require('./client/staff.js').default,
	Visit        : require('./client/visit.js').default,
	Visit_survey : require('./client/visit_survey.js').default,

	common: {
		Date   : require('../../client/date.js').default,
		Form   : require('../../client/form.js').default,
		Helper : require('../../client/helper.js').default,
		Image  : require('../../client/image.js').default,
		Is     : require('../../client/is.js').default,
		Log    : require('../../client/log.js').default,
		Network: require('../../client/network.js').default,
		Tab    : require('../../client/tab.js').default,
		Table  : require('../../client/table.js').default,
		Toast  : require('../../client/toast.js').default,
		Tooltip: require('../../client/tooltip.js').default,
		Ui     : require('../../client/ui.js').default,
	},
}
